import React from 'react';
import './EditorContainerProfile.css';
import EditableField from '../EditableField/EditableField';
import formatPhoneNumber from '../../utils/formatPhoneNumber';

const EditorContainerProfile = ({
  formData,
  categories,
  handleChangeFormData,
  canEdit,
}) => {
  return (
    <div
      className='editor-container-profile'
      id='intranet-user-profile_container'
    >
      <form
        className='editor-container-profile__form'
        onSubmit={(e) => e.preventDefault()}
      >
        <div className='editor-container-profile__column-wrapper'>
          <div className='editor-container-profile__column-content'>
            <div
              className='editor-container-profile__section'
              data-cid='contact'
            >
              <div className='editor-container-profile__section-content editor-container-profile__section-content-padding-right'>
                {categories
                  .filter((item) => !item.disabled)
                  .map((item) => (
                    <EditableField
                      key={item.name}
                      value={
                        item.name === 'phone'
                          ? formatPhoneNumber(formData[item.name])
                          : formData[item.name] || ''
                      }
                      field={item}
                      disabled={canEdit}
                      error={
                        formData.errors
                          ? formData?.errors[item?.name] || ''
                          : ''
                      }
                      onChange={(value) =>
                        handleChangeFormData(item.name, value)
                      }
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
        <input type='hidden' name='EDITOR_CONFIG_ID' value='' />
      </form>
    </div>
  );
};

export default EditorContainerProfile;
